import { trackAnalyticsNew } from '../../../../lib/utils';

export const getBrowseCategoriesAnalytics = ({ analyticsSlug, url }) => (
  trackAnalyticsNew({
    url,
    location: 'page:header-nav:level-2:browse-categories',
    name: analyticsSlug,
  })
);
